import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-limit-warning',
  templateUrl: './user-limit-warning.component.html',
  styleUrl: './user-limit-warning.component.css'
})
export class UserLimitWarningComponent {

  @Input() exceededUsers: number = 0;

  @Output() manageUsers = new EventEmitter<void>();

  onManageUsers(): void {
    this.manageUsers.emit();
  }
}